// extracted by mini-css-extract-plugin
export var deliveryRow = "_t1-a";
export var fixedHeight = "_t1-4";
export var freightLogo = "_t1-9";
export var fullWidth = "_t1-3";
export var priceColumn = "_t1-5";
export var radioSelected = "_t1-7";
export var radioUnselected = "_t1-6";
export var selectedOption = "_t1-2";
export var selectedOptionContainer = "_t1-1";
export var selection = "_t1-0";
export var tallSkeletonText = "_t1-8";